// Brand Slider
var swiper = new Swiper(".brand-slider", {
  slidesPerView: 5,
  slidesPerGroup: 5,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    280: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    481:{
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
    768: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
    1024: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    },
  },
});